import { render, staticRenderFns } from "./productRecycleBin.vue?vue&type=template&id=1b89519b&scoped=true"
import script from "./productRecycleBin.vue?vue&type=script&lang=js"
export * from "./productRecycleBin.vue?vue&type=script&lang=js"
import style0 from "./productRecycleBin.vue?vue&type=style&index=0&id=1b89519b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89519b",
  null
  
)

export default component.exports